"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEnded = exports.isEndingSoon = void 0;
var moment_1 = __importDefault(require("moment"));
var isEndingSoon = function (endingSoon, entryEnd) {
    return !!endingSoon &&
        !!entryEnd &&
        (0, moment_1.default)(endingSoon).isBefore((0, moment_1.default)()) &&
        (0, moment_1.default)(entryEnd).isAfter((0, moment_1.default)());
};
exports.isEndingSoon = isEndingSoon;
var isEnded = function (end) { return !!end && (0, moment_1.default)(end).isBefore((0, moment_1.default)()); };
exports.isEnded = isEnded;
//# sourceMappingURL=rewardUtil.js.map